export const faqConstants = {
    FAQ_LIST_PENDING: 'FAQ_LIST_PENDING',
    FAQ_LIST_FULFILLED: 'FAQ_LIST_FULFILLED',
    FAQ_LIST_REJECTED: 'FAQ_LIST_REJECTED',

    FAQ_DETAIL_PENDING: 'FAQ_DETAIL_PENDING',
    FAQ_DETAIL_FULFILLED: 'FAQ_DETAIL_FULFILLED',
    FAQ_DETAIL_REJECTED: 'FAQ_DETAIL_REJECTED',
    FAQ_DETAIL_CLEAR: 'FAQ_DETAIL_CLEAR',

    CREATE_FAQ_PENDING: 'CREATE_FAQ_PENDING',
    CREATE_FAQ_FULFILLED: 'CREATE_FAQ_FULFILLED',
    CREATE_FAQ_REJECTED: 'CREATE_FAQ_REJECTED',
    CREATE_FAQ_CLEAR: 'CREATE_FAQ_CLEAR',

    UPDATE_FAQ_PENDING: 'UPDATE_FAQ_PENDING',
    UPDATE_FAQ_FULFILLED: 'UPDATE_FAQ_FULFILLED',
    UPDATE_FAQ_REJECTED: 'UPDATE_FAQ_REJECTED',
    UPDATE_FAQ_CLEAR: 'UPDATE_FAQ_CLEAR',

    DELETE_FAQ_PENDING: 'DELETE_FAQ_PENDING',
    DELETE_FAQ_FULFILLED: 'DELETE_FAQ_FULFILLED',
    DELETE_FAQ_REJECTED: 'DELETE_FAQ_REJECTED',
    DELETE_FAQ_CLEAR: 'DELETE_FAQ_CLEAR',

    SORT_FAQ_PENDING: 'SORT_FAQ_PENDING',
    SORT_FAQ_FULFILLED: 'SORT_FAQ_FULFILLED',
    SORT_FAQ_REJECTED: 'SORT_FAQ_REJECTED',
    SORT_FAQ_CLEAR: 'SORT_FAQ_CLEAR',

    TRANSLATE_FAQ_PENDING: 'TRANSLATE_FAQ_PENDING',
    TRANSLATE_FAQ_FULFILLED: 'TRANSLATE_FAQ_FULFILLED',
    TRANSLATE_FAQ_REJECTED: 'TRANSLATE_FAQ_REJECTED',
    TRANSLATE_FAQ_CLEAR: 'TRANSLATE_FAQ_CLEAR',
};
